import {FC, useMemo} from 'react';
import {Divider} from '../../Divider';
import {Box} from '../../Box';
import {Typography} from '../../Typography';
import {useFileInputContext} from '../FileInputContext';
import {niceBytes} from '../../helpers/niceBytes';
import {CSSObject} from '@mui/material';
import {Tooltip} from '../../Tooltip';
import HelpIcon from '@mui/icons-material/Help';

export const FileInputGuardsPanel: FC<unknown> = () => {
    const {
        accept, minSize, maxSize, maxFiles, textMap, showHelperText
    } = useFileInputContext();

    const renderAcceptedFiles = useMemo(() => {
        return Object.values(accept).flat().join(', ');
    }, [accept]);

    return (
        <div>
            {textMap.guardTitle && (
                <>
                    <Box
                        alignItems='center'
                        display='flex'
                    >
                        <Typography
                            marginRight='0.25rem'
                            variant='subtitle1'
                        >{textMap.guardTitle}</Typography>
                        {showHelperText && (
                            <Tooltip title={textMap.guardSupplement}>
                                <HelpIcon
                                    color='action'
                                    sx={{
                                        fontSize: '1rem'
                                    }}
                                />
                            </Tooltip>
                        )}
                    </Box>
                    <Divider
                        sx={(theme): CSSObject => ({
                            marginBottom: theme.tokens.FuelSpacing1
                        })}
                    />
                </>
            )}
            <Typography
                display='block'
                noWrap
                title={`Accepted Files: ${renderAcceptedFiles}`}
                variant='body2'
            >
                <strong role='term'>{`${textMap.guardAcceptedFiles}: `}</strong>
                <span role='definition'>{renderAcceptedFiles}</span>
            </Typography>
            <Typography
                display='block'
                noWrap
                variant='body2'
            >
                <strong role='term'>{`${textMap.guardMinSize}: `}</strong>
                <span role='definition'>{niceBytes(minSize)}</span>
            </Typography>
            <Typography
                display='block'
                noWrap
                variant='body2'
            >
                <strong role='term'>{`${textMap.guardMaxSize}: `}</strong>
                <span role='definition'>{maxSize === Infinity ? 'Infinity' : niceBytes(maxSize)}</span>
            </Typography>
            <Typography
                display='block'
                noWrap
                variant='body2'
            >
                <strong role='term'>{`${textMap.guardMaxFiles}: `}</strong>
                <span role='definition'>{maxFiles}</span>
            </Typography>
        </div>
    );
};
